module.exports = __webpack_public_path__ + "img/toggle-grids.abfa164b.gif";